import { render, staticRenderFns } from "./SwatchCopyProduct.vue?vue&type=template&id=8c6e5bf8&scoped=true&"
import script from "./SwatchCopyProduct.vue?vue&type=script&lang=js&"
export * from "./SwatchCopyProduct.vue?vue&type=script&lang=js&"
import style0 from "./SwatchCopyProduct.vue?vue&type=style&index=0&id=8c6e5bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6e5bf8",
  null
  
)

export default component.exports